import request from '@/lib/api'

const _BASE = "/api";

// 获取全部通知
export function getMsgAll() {
    return request({
        url: `${_BASE}/tPmcInformation`,
        method: 'get',
    })
}
// 通知状态，开启关闭
export function switchStstus(params) {
    return request({
        url: `${_BASE}/tPmcInformation/switch`,
        method: 'get',
        params
    })
}
// 通知对象，选中或未选中
export function objStstus(params) {
    return request({
        url: `${_BASE}/tPmcInformation/switch`,
        method: 'get',
        params
    })
}

// 消息编辑，获取详情
export function msgDetails(id) {
    return request({
        url: `${_BASE}/tPmcInformation/${id}`,
        method: 'get',
    })
}

// 短信配置，短信测试
export function msgTest(phone, params) {
    return request({
        url: `${_BASE}/tPmcInformation/message/${phone}`,
        method: 'get',
        params
    })
}

// 短信配置，内容提交
export function msgSave(params) {
    return request({
        url: `${_BASE}/tPmcInformation/message`,
        method: 'post',
        params
    })
}

// 邮箱配置，邮箱测试
export function emailTest(email, params) {
    return request({
        url: `${_BASE}/tPmcInformation/email/${email}`,
        method: 'get',
        params
    })
}

// 邮箱配置，内容提交
export function emailSave(params) {
    return request({
        url: `${_BASE}/tPmcInformation/email`,
        method: 'post',
        data:params
    })
}

//邮箱配置，内容回显
export function getEmail() {
    return request({
        url: `${_BASE}/tPmcInformation/getEmail`,
        method: 'get',
    })
}

// 短信配置，内容回显
export function getMessage() {
    return request({
        url: `${_BASE}/tPmcInformation/getMessage`,
        method: 'get',
    })
}